import { render, staticRenderFns } from "./AllocationModel.vue?vue&type=template&id=6bfe2371&"
import script from "./AllocationModel.vue?vue&type=script&lang=js&"
export * from "./AllocationModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports